var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "pos-absolute": !_vm.isMobile } }, [
    !_vm.isMobile
      ? _c("div", [
          _c("div", { staticClass: "triangle", class: _vm.triangleClass }),
          _vm._v(" "),
          _c("span", {
            staticClass: "label label-primary",
            domProps: { innerHTML: _vm._s(_vm.label) }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isMobile && (_vm.hasLabel || _vm.isBundle || _vm.isSet)
      ? _c("div", { staticClass: "special-tags p-2" }, [
          _vm.hasLabel
            ? _c("span", {
                staticClass: "badge",
                class: _vm.tagClass,
                domProps: { innerHTML: _vm._s(_vm.label) }
              })
            : _vm.isBundle
            ? _c("span", { class: _vm.tagClasses.itemBundle }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$translate("Ceres::Template.itemBundle")) +
                    "\n        "
                )
              ])
            : _vm.isSet
            ? _c("span", { class: _vm.tagClasses.itemSet }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$translate("Ceres::Template.itemSet")) +
                    "\n        "
                )
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }